<template>
  <div class="layout-container flex justify-center"
       :class="{
		  'column':navPos === 'top' || navPos === 'bottom',
		  'boxed':boxed,
		  'footer-above':footer === 'above',
		  'content-only':!navPos
	  }">

    <transition name="fade">
      <div class="splash-screen" v-if="splashScreen">
        <div class="wrap">
          <div class="wrap lds-ellipsis"><div></div><div></div><div></div><div></div></div>
        </div>
      </div>
    </transition>

    <vertical-nav
      :position="navPos"
      :collapse-nav="collapseNav"
      :open-sidebar.sync="openSidebar"
      @push-page="closeSidebar"
      v-if="navPos === 'left'"/>

    <div class="container flex column box grow">

      <div class="header" v-if="toolbar === 'top'">
        <Toolbar @toggle-sidebar="openSidebar = !openSidebar" :menu-burger="navPos"/>
      </div>
      <horizontal-nav :position="navPos" @push-page="closeSidebar" v-if="navPos === 'top'"/>
      <div class="header" v-if="toolbar === 'bottom'">
        <Toolbar @toggle-sidebar="openSidebar = !openSidebar" :menu-burger="navPos"/>
      </div>

      <PlatformNoticeBanner v-if="isLogged"/>

      <div class="main box grow flex">
        <span class="main-out-border--top-left" v-if="roundedCorners"></span>
        <span class="main-out-border--top-right" v-if="roundedCorners"></span>
        <span class="main-out-border--bottom-left" v-if="roundedCorners"></span>
        <span class="main-out-border--bottom-right" v-if="roundedCorners"></span>
        <transition :name="viewAnimation" mode="out-in">
          <router-view class="view box grow"/>
        </transition>
        <Keypad @softphoneDial="dialSoftphone"/>
      </div>

      <horizontal-nav :position="navPos" @push-page="closeSidebar" v-if="navPos === 'bottom'" style="margin-bottom:0;"/>

      <Footer v-if="footer === 'below'" :position="footer"/>
    </div>

    <vertical-nav
      :position="navPos"
      :collapse-nav="collapseNav"
      :open-sidebar.sync="openSidebar"
      @push-page="closeSidebar"
      v-if="navPos === 'right'"/>

    <Footer v-if="footer === 'above'" :position="footer"/>

<!--    SOUNDS-->
    <div id="call-accepted">
      <audio src="https://global-app.s3.amazonaws.com/omnia-assets/start_notification.mp3" type="audio/mpeg"></audio>
    </div>
    <div id="call-ringing">
      <audio :src="incomingRingTone" type="audio/wav" loop></audio>
    </div>
    <div id="call-ended">
      <audio src="https://global-app.s3.amazonaws.com/omnia-assets/end_notification.mp3" type="audio/mpeg"></audio>
    </div>
    <div id="outbound-call-ringing">
      <audio src="https://global-app.s3.amazonaws.com/omnia-assets/phone_sounds_outgoing.mp3" type="audio/wav" loop></audio>
    </div>
    <div id="call-waiting-sound">
      <audio src="https://global-app.s3.amazonaws.com/omnia-assets/call_waiting.mp3" type="audio/mpeg"></audio>
    </div>

<!--    STREAMS-->
    <video id="video-local" autoplay style="display: none;"></video>
    <video id="video-remote" autoplay style="display: none;"></video>

<!--    MIGHT NEED TO INJECT MULTIPLE INSTANCES OF THESE-->
    <incoming-call
      modalHandleId="0"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>
    <incoming-call
      modalHandleId="1"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>
    <incoming-call
      modalHandleId="2"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>
    <incoming-call
      modalHandleId="3"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>
    <incoming-call
      modalHandleId="4"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>
    <incoming-call
      modalHandleId="5"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>
    <incoming-call
      modalHandleId="6"
      @acceptCall="answerCall"
      @declineCall="declineCall">
    </incoming-call>


<!--    THIS IS LIKELY GOING TO MOVE TO ITS OWN COMPONENT WITH LAUNCH OF NEW NETWORK FEATURES-->
    <el-dialog
      width="30%"
      :visible="networkTestVisible"
      :before-close="hideNetworkTest"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="network-troubleshooting">
        <div class="troubleshoot-header flex align-center justify-space-between">
          <h2 class="form-section-header mb-0 flex">Network Test</h2>
          <div class="network-test-buttons ml-10">
            <el-button
              @click="startNetworkTest"
              :disabled="networkTestActive || !softphoneEnabled"
            >
              Go
            </el-button>
          </div>
        </div>
        <hr>
        <el-tag type="warning" v-if="!softphoneEnabled">
          <i class="el-icon-warning" />
          <span class="ml-5">Your softphone must be enabled</span>
        </el-tag>
        <p class="black-text">
          Click Go to test the quality of the internet connection to our server. 
        </p>
        <h3 class="mb-0 black-text">Latency</h3>
        <span class="black-text">Acceptable values are less than 100ms</span>
        <h3 class="mb-0 black-text">Packet Loss</h3>
        <span class="black-text">Acceptable values are less the 0.5%</span>
        <h3 class="mb-0 black-text">Jitter</h3>
        <span class="black-text">Acceptable values are less than 1%.</span>
        <h3 class="mb-0 black-text">Mean Opinion Score (MOS)</h3>
        <div class="network-test-table">
          <vxe-table
            class="network-test-table"
            show-overflow
            highlight-hover-row
            :show-header="false"
            empty-text="No Test Data"
            :data="mosTableData">
            <vxe-table-column field="name"></vxe-table-column>
            <vxe-table-column field="value"></vxe-table-column>
          </vxe-table>
        </div>
      </div>
      <div class="mt-10 network-test-table">
        <h3 class="mb-0 black-text">
          Test Results:
        </h3>
        <vxe-table
          show-overflow
          highlight-hover-row
          :show-header="false"
          empty-text="No Test Data"
          :loading="networkTestActive"
          :data="networkTestData">
          <vxe-table-column field="name"></vxe-table-column>
          <vxe-table-column field="value"></vxe-table-column>
        </vxe-table>
      </div>
    </el-dialog>

    <PlantronicsController v-if="plantronicsEnabled" />

  </div>
</template>


<script>
  import {detect} from 'detect-browser'

  const browser = detect()
  import HorizontalNav from '@/core/horizontal-nav.vue';
  import VerticalNav from '@/core/vertical-nav.vue';
  import Toolbar from '@/core/toolbar.vue';
  import Footer from '@/core/footer.vue';
  import PlatformNoticeBanner from '@/core/platform-notice-banner.vue';
  import Keypad from '../src/views/hudportal/softphone/components/keypad';
  import IncomingCall from '../src/views/hudportal/softphone/components/incoming-call-draggable';
  import PlantronicsController from '../src/views/hudportal/softphone/components/plantronics';

  import feathersClient, {apiV2Host} from "./feathers/feathers-client";
  import {globalEventBus} from './globalEventBus';
  import {mapGetters} from 'vuex';
  import extensionStatus from "./ref/extension-status";
  import VOXOSip from './softphone/VOXOSip';
  import {isMobileDevice, phoneNumberFormatter} from "./globals/globals";
  import moment from 'moment';
  import { debounce } from 'lodash';

  export default {
    name: 'App',
    components: {
      HorizontalNav,
      VerticalNav,
      Toolbar,
      Footer,
      PlatformNoticeBanner,
      Keypad,
      IncomingCall,
      PlantronicsController
    },
    data() {
      return {
        openSidebar: false,
        tenantSettingsPromise: null,
        innerWidth: 0,
        numHelpers: 3,
        textRoom: null,
        opaqueId: null,
        modKeyActive: false,
        networkTestActive: false,
        sipDad:  null,
        freeIncomingModals: [0,1,2,3,4,5,6],
        networkTestData: [],
        softphoneRegistered: false,
        sipRegisterRequested: false,
        softphoneDisabledByDisconnect: false,
        mosTableData: [
          {name: 'Best', value: 'over 4.34'},
          {name: 'High', value: '4.03 - 4.34'},
          {name: 'Medium', value: '3.6 - 4.03'},
          {name: 'Low', value: '3.1 - 3.6'},
          {name: 'Poor', value: 'below 3.1'}
        ]
      }
    },
    metaInfo(){

      if(this.branding){
        const manifestLink = document.querySelector('link[rel="manifest"]');
        manifestLink.href = `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/manifest.json`;

        return {
          title: `${this.branding.themeName} - Unified Communications Platform`,
          link: [
            {rel: 'canonical', href: this.branding.themeWebsite},
            {rel: 'shortcut icon', href: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon.ico`},
            {rel: 'apple-touch-icon', type: 'image/png', sizes: '180x180', href: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon-180.png`},
            {rel: 'icon', type: 'image/png', sizes: '196x196', href: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon-192.png`},
            {rel: 'icon', type: 'image/png', sizes: '32x32', href: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon-32.png`},
            {rel: 'icon', type: 'image/png', sizes: '96x96', href: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon-96.png`},
            {rel: 'icon', type: 'image/png', sizes: '16x16', href: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon-16.png`}
          ],
          meta: [
            {name: 'apple-mobile-web-app-title', content: `${this.branding.themeName}`},
            {name: 'msapplication-TileImage', content: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/favicon-144.png`},
            {name: 'author', content: this.branding.themeName},
            {name: 'image', content: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/fav.png`},
            {name: 'twitter:title', content: `${this.branding.themeName} - Unified Communications Platform`},
            {name: 'twitter:site', content: this.branding.twitterHandle},
            {name: 'twitter:creator', content: this.branding.twitterHandle},
            {name: 'twitter:image', content: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/preview.png`},
            {name: 'og:title', content: `${this.branding.themeName} - Unified Communications Platform`},
            {property: 'og:title', content: `${this.branding.themeName} - Unified Communications Platform`},
            {name: 'og:site_name', content: `${this.branding.themeName} - Unified Communications Platform`},
            {property: 'og:site_name', content: `${this.branding.themeName} - Unified Communications Platform`},
            {name: 'og:image', content: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/preview.png`},
            {property: 'og:image', content: `https://global-app.s3.amazonaws.com/omnia-assets/themes/${this.branding.themeFolder}/preview.png`},
            {name: 'og:url', content: this.branding.appDomain},
            {property: 'og:url', content: this.branding.appDomain}
          ]
        }
      }

    },
    computed: {
      ...mapGetters('mycurrentcalls', {myCallsList: 'find'}),
      ...mapGetters('phonebook-entries', {loadPersonalDirectory: 'find'}),
      navPos() {
        if (this.innerWidth <= 768 && (this.$store.getters.navPos === 'top' || this.$store.getters.navPos === 'bottom')) {
          return 'left'
        }
        return this.$store.getters.navPos
      },
      toolbar() {
        return this.$store.getters.toolbar
      },
      footer() {
        return this.$store.getters.footer
      },
      boxed() {
        return this.$store.getters.boxed
      },
      roundedCorners() {
        return this.$store.getters.roundedCorners
      },
      viewAnimation() {
        return this.$store.getters.viewAnimation || 'none'
      },
      isLogged() {
        return this.$store.getters.isLogged
      },
      splashScreen() {
        return this.$store.getters.splashScreen
      },
      currentRoute(){
        return this.$route;
      },
      collapseNav(){
        return this.$store.state.collapseNav;
      },
      user(){
        return this.$store.state.auth.user;
      },
      audioInputDevice(){
        return this.$store.state.audioInputDeviceId;
      },
      softphoneEnabled(){
        return this.$store.state.softphoneEnabled;
      },
      keyPadVisible(){
        return this.$store.state.softphoneVisible;
      },
      networkTestVisible(){
        return this.$store.state.networkTestVisible;
      },
      outboundRingVolume(){
        return this.$store.state.outboundRingVolume;
      },
      branding(){
        return this.$store.state.branding;
      },
      incomingRingTone() {
        return this.$store.state.incomingRingTone;
      },
      plantronicsEnabled() {
        return this.$store.state.plantronicsEnabled && this.$store.state.softphoneEnabled;
      },
      location() {
        return this.$store.state.location;
      }
    },
    methods: {
      resizeOpenNav() {
        this.innerWidth = window.innerWidth
        if (window.innerWidth <= 768) {
          this.$store.commit('setCollapsedNav', false);
        }
      },
      closeSidebar() {
        this.openSidebar = false
      },
      //Unloading the page takes the softphone with it, so a live call dies with
      //no warning. preventDefault is what makes the browser show its own prompt;
      //returnValue is the older spelling Safari and Firefox still want.
      confirmUnloadDuringCall(event) {
        if(!this.sipDad || !this.sipDad.hasActiveCall()){ return; }
        event.preventDefault();
        event.returnValue = "";
        return "";
      },
      getStatusFromEvent(code) {
        return extensionStatus(code)
      },
      pushedConnected(item){
        if(item.status === 'RINGINUSE'){item.status = 'RINGING'}
        if((item.status === 'INUSE' || 'RINGING') && item.direction.length){
          if(item.cidnum === '' || item.cidnum === '<unknown>'){
            return false;
          }
          return true;
        } else {
          return false;
        }
      },
      checkCallExists(item){
        const queryCall = this.myCallsList({query: {channel: item.channel}}).data;
        return !!queryCall.length;
      },
      callButtonStatus(item){
        return item.status === 'RINGING';
      },
      async verifyAudioDeviceId(){

        let device = this.audioInputDevice;
        const availableDevice = await navigator.mediaDevices.enumerateDevices();
        const inputDevices = availableDevice.filter(item => item.kind === 'audioinput').map(item => item.deviceId);

        if(!inputDevices.length){
          device = null;
          return device;
        }

        if(inputDevices.includes(this.audioInputDevice)){
          return this.audioInputDevice;
        } else{
          this.$store.commit('setAudioInputDeviceId', 'default');
          return 'default';
        }
      },
      async answerCall(sipHandle){

        const {handleId, uniqueId} = sipHandle;

        //Put All The Other Calls On Hold
        await this.sipDad.holdOtherCalls(uniqueId);

        const audioDeviceId = await this.verifyAudioDeviceId();

        if(!audioDeviceId){
          this.sipDad.hangup(uniqueId);
          this.$notify({
            title: 'Warning',
            message: 'No Audio Devices Found To Handle Media. Softphone Is Disabled',
            type: 'warning'
          });
          this.$store.commit('setSoftphoneEnabled', false);
          return;
        }

        //Answer The Call
        const inviteAcceptOptions = {
          sessionDescriptionHandlerOptions: {
            constraints: {
              audio: {deviceId: {exact: audioDeviceId}}
            }
          }
        };

        try {
          await this.sipDad.answer(uniqueId, inviteAcceptOptions);
          globalEventBus.$emit('softphoneCallAccepted-'+handleId);
          globalEventBus.$emit('softphoneCallAccepted', sipHandle);
          globalEventBus.$emit('notifyHeadsetAnswered', uniqueId);

          //get the number of this call
          const number = this.sipDad.getCidNum(uniqueId);

          // ⭐️ `ACCEPT CALL` user event log ⭐️ //
          this.$store.dispatch("userEvents/create", {
            event: "Accept Call",
            number
          });

        } catch (e) {
          console.log('problem answering call', e);
        }
      },
      async declineCall(sipHandle) {
        const {uniqueId} = sipHandle;

        try {
          const number = this.sipDad.getCidNum(uniqueId);
          await this.sipDad.decline(uniqueId);


          // ⭐️ `DECLINE CALL` user event log ⭐️ //
          this.$store.dispatch("userEvents/create", {
            event: "Reject Call",
            number
          });

        } catch (e) {
          console.log('problem declining call', e);
        }
      },
      async dialSoftphone(number){
        const isEmergency = number === "911" || number === "933";

        if (isEmergency) {
          const findLoc = this.$notify({
            title: "Determining Location",
            showClose: false,
            type: "warning",
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: `<div class="offline-notification" style="display: flex; margin-left: -40px;">
                      <div class="el-loading-spinner mt-20" style="position: relative; width: auto;">
                        <svg viewBox="13 13 25 25" class="circular">
                          <circle cx="25" cy="25" r="10" fill="none" class="path"></circle>
                        </svg>
                      </div>
                      <div class="ml-20 mt-20">We are trying to determine your location for emergency services</div>
                    </div>`
          });
          await this.$store.dispatch("promptCurrentLocation");
          findLoc.close();
        }

        //grab number to call
        const uri = `sip:${number}@sip.voxo.co`;

        //hold other calls in progress
        await this.sipDad.holdOtherCalls();

        //update connected call widgets to reflect hold
        const currentCalls = this.myCallsList().data;
        for(let i = 0; i < currentCalls.length; i++){
          const {channel} = currentCalls[i];
          this.$store.commit('mycurrentcalls/updateItem', {channel, onHold: true});
        }

        const audioDeviceId = await this.verifyAudioDeviceId();

        if(!audioDeviceId){
          this.$notify({
            title: 'Warning',
            message: 'No Audio Devices Found. Softphone Is Disabled',
            type: 'warning'
          });
          this.$store.commit('setSoftphoneEnabled', false);
          return;
        }

        //setUpInviterOptions
        const inviterOptions = {
          sessionDescriptionHandlerOptions: {
            constraints: {
              audio: {deviceId: {exact: this.audioInputDevice}}
            }
          }
        };
        //setUpEmergencyDetails
        const emergencyDetails = {
          isEmergency,
          userLocation: {
            lat: this.location.lat,
            long: this.location.long,
          },
        };

        //Do Tha Dern Thing
        const { outboundRecord } = this.user.myExtension;
        this.sipDad.call(uri, inviterOptions, emergencyDetails, {}, outboundRecord)
					.then(() => {
						// ⭐️ `OUTBOUND CALL` user event log ⭐️ //
            // Try to not include feature code dials
            const isFeature = number.startsWith('*') && number.length < 9;

						if(!isFeature && !number.startsWith('#')) {
							this.$store.dispatch("userEvents/create", {
								event: "Outbound Call",
								number
							});
						}
					})
					.catch( e => {
						this.$notify({
							title: 'Call Failed',
							message: 'Please confirm that your audio device is selected and available.',
							type: 'error'
						});
					});
      },
      updateStoreCalls(callCidnum, sipHandle){
        const calls = this.myCallsList().data;
        if(calls.length){
          for(let i = 0; i < calls.length; i++){
            const {channel, sipHandle: callSipHandle, softphoneCall} = calls[i];

            if(callSipHandle){
              if(softphoneCall && callSipHandle.uniqueId === sipHandle.uniqueId){
                this.$store.commit('mycurrentcalls/updateItem', {channel, softphoneCall: true, sipHandle, onHold: false, buttonsReady: true});
              } else {
                this.$store.commit('mycurrentcalls/updateItem', {channel, onHold: true});
              }
            } else{
              this.$store.commit('mycurrentcalls/updateItem', {channel, onHold: callSipHandle ? callSipHandle.uniqueId === sipHandle.uniqueId : true});
            }
          }
        }
      },
      bustCall(cidnum){
        const call = this.myCallsList({
          query: {
            cidnum
          }
        }).data;
        if(call.length){
          if(this.user.integrationId){
            globalEventBus.$emit('userCallHangup', call[0]);
          }
          this.$store.commit('mycurrentcalls/removeItem', call[0].channel);
        }
        if(!this.myCallsList().data.length){
          this.$store.commit('setUserStatus', 'NOT_INUSE');
        }
      },
      clearMyCalls(){
        //this only clears calls that are not softphone calls
        const calls = this.myCallsList({
          query: {
            softphoneCall: false
          }
        }).data;
        if(calls.length){
          this.$store.commit('mycurrentcalls/removeItems', calls);
        }
      },
      emitConferenceChannel(evt){
        globalEventBus.$emit('conferenceChannel', evt);
      },
      emitConferenceInfoComplete(evt){
        globalEventBus.$emit('conferenceInfoComplete', evt);
      },
      async joinUserChannels(){
        const natsHandler = feathersClient.service('nats-actions-handler');
        if(this.user.hasOwnProperty('myExtension')){
          //join users specific socket channel
          await feathersClient.service('channel-memberships').create({
            roomType: 'user',
            peerName: this.user.myExtension.peerName
          }).catch( (e) => console.log('error in joining user room', e));

          if(this.$route.name !== 'OMNIA Queues' && this.user.myExtension.peerName){
            await natsHandler.create({
              reqType: 'refreshConnectedCalls',
              hostServer: this.user.myExtension.hostServer,
              peerName: this.user.myExtension.peerName,
              tenantCode: this.user.myExtension.tenantCode,
              tenantId: this.user.myExtension.tenantId,
              userId: this.user.id,
              userExten: this.user.myExtension.number,
              peerNames: [this.user.myExtension.peerName]
            }).then( () => {
              setTimeout( () => {
                const hasCalls = this.myCallsList().data.length;
                if(!hasCalls){
                  this.$store.commit('setUserStatus', 'NOT_INUSE');
                }
              }, 5000);
            }).catch( (e) => console.log('error in refreshing user calls', e));
          }
        }
      },
      notificationPermissionRequest(){

        Notification.requestPermission().then( (result) => {
          //if permission was granted go ahead and subscribe the user
          if(result === 'granted'){
            //subscribe the user by default
            console.log('permission accepted!');
          } else{
            console.log('notifications denied permission!')
          }
        });
      },
      prettyNumber(number) {
        return number ? phoneNumberFormatter(number) : number;
      },
      callPushNotify(handleId, number, callerName, transferrer){
        //this is web push. Need to pass sip info across event so we can answer and decline from click
        if(this.softphoneEnabled){
          navigator.serviceWorker.ready.then( (reg) => {

            const body = transferrer
              ? `${callerName ? callerName.replace(/"/g, '') : 'Unknown'} | ${this.prettyNumber(number)} \n Transferred By: ${transferrer}`
              : `${callerName ? callerName.replace(/"/g, '') : ''} | ${this.prettyNumber(number)}`;

            if(this.user.enableCallNotifications){
              const options = {
                badge: 'https://global-app.s3.amazonaws.com/omnia-assets/logo96.png',
                icon: 'https://global-app.s3.amazonaws.com/omnia-assets/logo96.png',
                body,
                data: {sipHandleId: handleId},
                requireInteraction: true,
                actions: [
                  {action: 'acceptCall', title: 'Accept'},
                  {action: 'declineCall', title: 'Decline'}
                ]
              };
              reg.showNotification('Incoming Call', options);
            }
          });
        }
      },
      parkPushNotify(parkingSpace, number, callerName, parkerExt){
        //this is web push. Need to pass sip info across event so we can answer and decline from click
        const pushName = callerName === '<unknown>' ? 'Unknown' : callerName;
        if(this.softphoneEnabled){
          navigator.serviceWorker.ready.then( (reg) => {
            if(this.user.enableCallNotifications){
              const options = {
                badge: 'https://global-app.s3.amazonaws.com/omnia-assets/logo96.png',
                icon: 'https://global-app.s3.amazonaws.com/omnia-assets/logo96.png',
                body: `${pushName.replace(/"/g, '')} | ${this.prettyNumber(number)} \n Parked By Ext ${parkerExt}`,
                data: {parkingSpace},
                requireInteraction: true,
                actions: [
                  {action: 'pickupPark', title: 'Accept'},
                  {action: 'ignorePark', title: 'Decline'}
                ]
              };
              reg.showNotification('Call Park', options);
            }
          });
        }
      },
      async clearPushNotify(){
        try{
          const reg = await navigator.serviceWorker.getRegistration();
          const notifications = await reg.getNotifications({
            includeTriggered: true
          });
          notifications.forEach((notification) => {
            notification.close();
          });
        } catch (e) {
          console.log(e);
        }

      },
      hideNetworkTest(){
        this.$store.commit('setNetworkTestVisible', false);
        this.networkTestData = [];
      },
      startNetworkTest(){
        this.networkTestActive = true;
        this.networkTestData = [];
        this.dialSoftphone('*11111');

				// ⭐️ `NETWORK TEST` user event log ⭐️ //
				this.$store.dispatch('userEvents/create', {
					event: 'Network Test'
				});
      },
      destroyAndRecreateAudio(audioId) {
      const audioContainer = document.getElementById(audioId);
      const oldAudio = audioContainer.querySelector('audio');

      if (oldAudio) {
        // Stop the audio completely
        oldAudio.pause();
        oldAudio.currentTime = 0;
        oldAudio.src = '';

        // Remove the old audio element
        audioContainer.removeChild(oldAudio);
      }

      // Create a new audio element with the original source
      const newAudio = document.createElement('audio');

      switch (audioId) {
        case 'call-accepted':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/start_notification.mp3';
          newAudio.type = 'audio/mpeg';
          newAudio.loop = false;
          break;
        case 'call-ringing':
          newAudio.src = this.$store.state.incomingRingTone;
          newAudio.type = 'audio/wav';
          newAudio.loop = true;
          break;
        case 'call-ended':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/end_notification.mp3';
          newAudio.type = 'audio/mpeg';
          newAudio.loop = false;
          break;
        case 'outbound-call-ringing':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/phone_sounds_outgoing.mp3';
          newAudio.type = 'audio/wav';
          newAudio.loop = true;
          break;
        case 'call-waiting':
          newAudio.src = 'https://global-app.s3.amazonaws.com/omnia-assets/call_waiting.mp3';
          newAudio.type = 'audio/mpeg';
          newAudio.loop = false;
          break;
        default:
          break;
      }

      // Add the new audio element to the container
      audioContainer.appendChild(newAudio);
},
      async wait(ms) {
        return new Promise(resolve => {
          setTimeout(resolve, ms);
        });
      },
      async doOutboundDTMF(callCidnum){
        //we want to check if this outbound dial had any DTMF digits included.
        const dtmfStore = {...this.$store.state.dtmfStore};
        if(dtmfStore[callCidnum]){
          //fetch the call information from the store
          const theCall = this.myCallsList({query: {cidnum: callCidnum}}).data;
          if(theCall.length){
            const {channel, sipHandle, systemname} = theCall[0];

            //update the call number in connected call to show digits.
            this.$store.commit('mycurrentcalls/updateItem', {channel, dtmfNums: [...dtmfStore[callCidnum]]});

            for(let k = 0; k < dtmfStore[callCidnum].length; k++){
              const dtmfDigits = dtmfStore[callCidnum][k].split('');
              await this.wait(2000);
              for(let j = 0; j < dtmfDigits.length; j++){
                await this.sipDad.sendDTMF(sipHandle.uniqueId, +dtmfDigits[j], {systemname, channel});
                await this.wait(50);
              }
            }
          }
          //destroy any dtmf that might exist
          this.$store.commit('removeDTMFNumbers', callCidnum);
        }
      },
      async softphoneInit(){

        if(!this.sipDad){

          //peer information for sip registration
          const extData = {...this.user.myExtension};
          const {peerName, peerSecret} = extData;

          //configure options for the SIP Client
          const options = {
            server: process.env.VUE_APP_WEBSOCKETS_HOST,
            sipAddress: `sip:${peerName}@sip.voxo.co`,
            logging: false,
            remoteStreamElement: document.getElementById('video-remote'),
            localStreamElement: document.getElementById('video-local'),
            feathersClient,
            provisionOptions: {
              displayName: peerName,
              authorizationUsername: peerName,
              authorizationPassword: peerSecret,
            }
          }

          //get this thing started
          this.sipDad = new VOXOSip(options);

          //Connect the User Agent
          this.sipDad.connect().catch(e => {
            console.log('sip user agent could not connect');
          });

          //SUCCESSFUL USER AGENT CONNECTION
          this.sipDad.on('connected', () => {
            console.log('the user agent is connected!');
            if(this.softphoneEnabled && !this.softphoneDisabledByDisconnect){
              this.requestSipRegistration();
            }
            //This is specifically to let our click to call extension know the app is ready to make calls
            setTimeout( () => {
              const vueStatus = new CustomEvent('vueAppStatus', {
                detail: {isReady: true}
              });
              window.dispatchEvent(vueStatus);
            }, 1000)
          });

          //Handle browser going offline
          this.sipDad.on('offline', () => {
            console.log('sip client is offline');

            this.softphoneRegistered = false;

            if(this.softphoneEnabled){
              //Set before softphoneEnabled goes false so the watcher can tell this
              //apart from the user switching the softphone off
              this.softphoneDisabledByDisconnect = true;
              this.softphoneLost = this.$notify({
                title: 'Softphone Disabled',
                message: 'Lost connection to network',
                type: 'error',
                duration: 0
              });
              this.$store.commit('setSoftphoneEnabled', false);
            }
            this.$store.commit('setSoftphoneLocked', true);
          })

          //Reconnect Successful
          this.sipDad.on('reconnected', async () => {
            console.log('we reconnected the user agent');
            await new Promise((resolve, reject) => {
              setTimeout( () => {
                if(this.softphoneDisabledByDisconnect){
                  console.log('softphone disabled by disconnect');
                  this.softphoneDisabledByDisconnect = false;
                  this.$store.commit('setSoftphoneEnabled', true);
                  if(this.softphoneLost) this.softphoneLost.close();
                } else {
                  this.$store.commit('setSoftphoneLocked', false);
                  if(this.softphoneLost) this.softphoneLost.close();
                }
                resolve();
              }, 500)
            });

            //The softphone re-registers itself on reconnect, but make sure the
            //registration is wanted in case we came back before the UI settled.
            if(this.softphoneEnabled) this.requestSipRegistration();
          });

          //SUCCESSFUL REGISTER EVENT
          this.sipDad.on('registered', () => {

            console.log('the softphone registered');
            this.softphoneRegistered = true;
            this.$store.commit('setSoftphoneLocked', false);

            //set status to Idle on Initial Registration
            this.$store.commit('setUserStatus', 'NOT_INUSE')
          });

          //REGISTRATION DROPPED
          this.sipDad.on('unregistered', () => {
            console.log('the softphone is no longer registered');
            this.softphoneRegistered = false;
          });

          //THE REGISTRAR REFUSED US - retried on a long backoff by the softphone
          this.sipDad.on('registrationFailed', (error) => {
            console.log('the softphone could not register', error && error.message);
            this.softphoneRegistered = false;
          });

          //INCOMING CALL EVENT
          this.sipDad.on('invite', async invitation => {

            //an invitation has been received and is ready to be accepted
            const {cidNum, cidName, transferrerExten, uniqueId, recording, canRecord, callId} = invitation;

            //fire an incoming call modal
            const handleId = this.freeIncomingModals[0];
            this.freeIncomingModals = [...this.freeIncomingModals.splice(1), handleId];
            invitation.handleId = handleId;

            //fire a generic softphone incoming call event
            globalEventBus.$emit('softphoneIncomingCall', {cidName, cidNum, recording, canRecord, callId});

            //look up the extension name for transferrer
            let transferrer = null;
            if(transferrerExten){
              const extenLookup = await feathersClient.service('extensions').find({
                query: {
                  tenantId: this.user.myExtension.tenantId,
                  number: transferrerExten
                }
              });
              transferrer = extenLookup.length ? `${extenLookup[0].name} - ${transferrerExten}` : transferrerExten;
            }

            globalEventBus.$emit('softphoneIncomingCall-'+handleId, {handleId, cidNum, transferrer, cidName, uniqueId, recording, canRecord, callId});
            this.callPushNotify(handleId, cidNum, cidName, transferrer);

            //notify headset if option enabled
            const headsetControlEnabled = true;
            if(headsetControlEnabled){
              globalEventBus.$emit('notifyHeadsetIncoming', {uniqueId, cidName, cidNum, handleId: invitation.handleId});
            }

          });

          //Invite Update On Existing Session
          this.sipDad.on('inviteUpdate', async data => {
            const {uniqueId, headers} = data;

            //parse the remote id header
            const cidName = headers['Remote-Party-Id'][0].raw.match(/".*"/)[0].replace(/"/g, '');
            const cidNum = headers['Remote-Party-Id'][0].raw.match(/<.*>/)[0].split('@')[0].replace(/.*sip:/, '');

            //find the call
            const calls = this.myCallsList().data;
            const theCall = calls.filter(item => item.sipHandle.uniqueId === uniqueId);

            //update
            if(theCall.length){
              const {channel} = theCall[0];
              this.$store.commit('mycurrentcalls/updateItem', {channel, cidnum: cidNum, cidname: cidName});
            }

          });

          //Call Is Trying to Go Out. Play The Ringback
          this.sipDad.on('trying', (session) => {
            const {uniqueId, cidName, cidNum} = session;

            // setTimeout( () => {
            //   this.flagSoftphone({uniqueId, cidNum, cidName});
            // }, 500)

            globalEventBus.$emit('notifyHeadsetOutbound', {uniqueId, cidName, cidNum});
            const ringback = document.getElementById('outbound-call-ringing').querySelector('audio');
            ringback.volume = this.outboundRingVolume;
            ringback.currentTime = 0;
            ringback.play();
          });

          //Catch Call Failed Event and Notify
          this.sipDad.on('callFailed', () => {
            this.$notify({
              title: 'Call failed',
              message: 'Please confirm the number and try again.',
              type: 'error'
            });
          })

          //An Invite Was Accepted Remotely
          this.sipDad.on('accepted', async invitation => {
            //Kill The Ringback Audio
            this.destroyAndRecreateAudio('outbound-call-ringing');

            const {cidNum, cidName, uniqueId, recording, canRecord, callId} = invitation;
            this.flagSoftphone({uniqueId, cidNum, cidName, recording, canRecord, callId});
            await this.sipDad.holdOtherCalls(uniqueId);
            setTimeout( () => {
              this.updateStoreCalls(cidNum, {cidNum, uniqueId, cidName});
            }, 200);
            this.doOutboundDTMF(cidNum);
          });

          //HANGUP EVENT
          this.sipDad.on('hangup', async invitation => {

            //kill any possible ringback audio and play end call tone
            this.destroyAndRecreateAudio('outbound-call-ringing');

            const endAudio = document.getElementById('call-ended').querySelector('audio');
            endAudio.play();

            //a hangup has occurred
            const {cidNum, handleId, uniqueId} = invitation;

            //bust the push notification, if any
            this.clearPushNotify();

            //remove call from store, if not already removed
            //not sure why this existed.
            // this.bustCall(cidNum);

            //if this was a network test set network test not active
            if(cidNum === '*11111') this.networkTestActive = false;

            //notify hangup to incoming call modal, if exists.
            globalEventBus.$emit('softphoneCallHangup-'+handleId);

            //notify the headset of the ended call if applicable
            globalEventBus.$emit('notifyHeadsetHangup', uniqueId)

            //destroy any dtmf that might exist
            this.$store.commit('removeDTMFNumbers', cidNum);
          });

          /*
          CALLS KILLED OFF BY A RECONNECT
          These sessions no longer exist anywhere in the SIP layer, so their widgets
          cannot hold, transfer or even hang up any more. Clear them out instead of
          leaving the user to dismiss dead controls by hand.
          */
          this.sipDad.on('callsAbandoned', sessions => {
            const abandonedIds = sessions.map(session => session.uniqueId);

            const dead = this.myCallsList().data
              .filter(call => call.sipHandle && abandonedIds.includes(call.sipHandle.uniqueId));

            for(let i = 0; i < dead.length; i++){
              //Keep integrations in step, the same way bustCall() does
              if(this.user.integrationId) globalEventBus.$emit('userCallHangup', dead[i]);
              this.$store.commit('mycurrentcalls/removeItem', dead[i].channel);
            }

            if(!this.myCallsList().data.length){
              this.$store.commit('setUserStatus', 'NOT_INUSE');
            }
          });

        }
      },
      //Ask the softphone to register. VOXOSip remembers the request and re-registers
      //itself after any reconnect, so calling this more than once is harmless.
      requestSipRegistration() {
        if(!this.sipDad || this.sipRegisterRequested) return;

        this.sipRegisterRequested = true;
        this.sipDad.register()
          .catch(e => {console.log('problem registering the softphone', e)})
          .then(() => {this.sipRegisterRequested = false});
      },
      flagSoftphone(sipHandle) {
        const calls = this.myCallsList({
          query: {
            cidnum: sipHandle.cidNum
          }
        }).data;
        if(calls.length){
          const {channel, cidnum, sipHandle: callSipHandle} = calls[calls.length - 1];
          if(cidnum === sipHandle.cidNum && !callSipHandle){
            const updateData = {
              channel,
              softphoneCall: true,
              sipHandle,
              onHold: false,
              answered: true,
            }
            this.$store.commit('mycurrentcalls/updateItem', updateData);
          }
        }
      },
      getTenantSettings() {
        // Memoize so mounted() and the user watcher share one request.
        if (this.tenantSettingsPromise) return this.tenantSettingsPromise;

        this.tenantSettingsPromise = (async () => {
          try {
            const res = await fetch(`${apiV2Host}/tenants/${this.user.tenantId}/settings`, {
              method: "GET",
              headers: {
                "Authorization": `Bearer ${this.$store.state.auth.accessToken}`,
                "Content-Type": "application/json",
              },
            });

            if (!res.ok) return null;
            return await res.json();
          } catch (_e) {
            return null;
          }
        })();

        return this.tenantSettingsPromise;
      },
      async bootIntercom() {
        if (!this.user) return;

        const settings = await this.getTenantSettings();
        const jwt = localStorage.getItem("feathers-jwt");
        const ext = this.user.myExtension;

        const payload = {
          email: this.user.email,
          user_id: this.user.id,
          company: {
            company_id: this.user.tenantId
          }
        };

        if (ext) {
          if (ext.name) payload.name = ext.name;
          if (ext.number) payload.phone = ext.number;
          if (ext.tenantId) payload.company.company_id = ext.tenantId;
        }

        if (settings && settings.name) {
          payload.company.name = settings.name;
        }

        if (jwt) {
          payload.access_token = jwt;
          payload.auth_tokens = {
            access_token: jwt
          };
        }

        this.$intercom.boot(payload);
      }
    },
    watch: {
      //this will just check the route to see if it falls in the HUD portal
      currentRoute(){
        this.currentRoute.meta.hudRoute ? this.$store.commit('setHudMode') : this.$store.commit('unsetHudMode');
      },
      user(){
        if(this.user){
          if(!isMobileDevice()){
            this.softphoneInit();
          }
          //intercom boot with user/tenant attributes
          this.bootIntercom();
        }
      },
      softphoneEnabled: debounce(function () {
        if(!this.sipDad) return;

        if(this.softphoneEnabled) {
          //Whoever turned it back on owns the softphone now, so the auto-disable
          //bookkeeping is void - a later toggle off has to be treated as real intent.
          this.softphoneDisabledByDisconnect = false;
          this.requestSipRegistration();
          return;
        }

        //A connection loss switches the softphone off by itself, and VOXOSip keeps its
        //registration intent so it comes back on reconnect. Leave that intent alone.
        if(this.softphoneDisabledByDisconnect) return;

        //A real decision to stop. This has to run even when we believe we are already
        //unregistered - it is what clears VOXOSip's intent, and without it recovery
        //would put the softphone back in service and ring for someone who turned it off.
        this.sipDad.unregister()
          .catch(e => {console.log('problem unregistering the softphone', e)})
          .then(() => {this.softphoneRegistered = false});
      }, 500)
    },
    created() {
      if (browser.name)
        document.getElementsByTagName("html")[0].classList.add(browser.name)
    },
    mounted() {

      this.resizeOpenNav();
      window.addEventListener('resize', this.resizeOpenNav);
      window.addEventListener('beforeunload', this.confirmUnloadDuringCall);

      const userService = feathersClient.service('users');
      const channelMemberships = feathersClient.service('channel-memberships');

      //for disable softphone if a mobile device
      if(isMobileDevice()){
        this.$store.commit('setSoftphoneEnabled', false);
      }

      //Register the softphone if we are not on mobile device
      if(this.user){
        if(!isMobileDevice()){
          this.softphoneInit();
        }

        //intercom boot with user/tenant attributes
        this.bootIntercom();
      }

      //execute notification permission request.
      this.notificationPermissionRequest();

      //listen for the DND status of the logged in user app wide.
      channelMemberships.on('dndStatus', (evt) => {
        this.$store.commit('setUserDND', evt.dndStatus === 'on');
      });

      //listen for presence on MY EXTENSION
      channelMemberships.on('myPresence', (evt) => {
        const {status, systemname, ishangup, event, channel, parkingSpace, cidname, cidnum, isAnswered} = evt;

        let callExists = this.checkCallExists(evt);
        //update caller information if this is a parking pick up.
        if(event === 'ParkPickup'){
          const theCall = [...this.myCallsList({query: {cidnum: parkingSpace}}).data];
          if(theCall.length){
            const channel = theCall[0].channel;
            this.$store.commit('mycurrentcalls/updateItem', {channel, cidname, cidnum, buttonsReady: true});
          }
          return;
        }

        if(ishangup){
          const theCall = [...this.myCallsList({query: {channel}}).data];
          if(this.user.integrationId && theCall.length){
            globalEventBus.$emit('userCallHangup', theCall[0])
          }
          //general hangup for any component to listen for
          globalEventBus.$emit('globalCallHangup', {...theCall[0], isAnswered});
          this.$store.commit('mycurrentcalls/removeItem', channel);
        } else{
          if(this.pushedConnected(evt)){
            if(callExists){
              const disabledButtons = this.callButtonStatus(evt);
              const updateData = {
                channel,
                cidname,
                disabledButtons,
                status
              };
              this.$store.commit('mycurrentcalls/updateItem', updateData);
            } else{
              const disabledButtons = this.callButtonStatus(evt);
              evt.duration = 0;
              evt.disabledButtons = disabledButtons;
              evt.softphoneCall = false;
              evt.sipHandle = null;
              evt.onHold = false;

              this.$store.commit('mycurrentcalls/addItem', evt);
            }
          }
        }

        this.$store.commit('setUserHostServer', systemname);

      });

      //handle parkCall available event
      channelMemberships.on('parkedCall', async (evt) => {
        this.$store.commit('myparkedcalls/addItem', evt);
        const {parkingSpace, callerNumber, callerName, parkerDialString, parkee, parkerNum} = evt;

        let parkerExten = JSON.parse(parkee);

        if(!parkerExten) {
          const splitDialString = parkerDialString.split('/')[1];
          parkerExten = splitDialString.split('-')[0];
        }

        //look up the extension name
        const extenLookup = await feathersClient.service('extensions').find({
          query: {
            tenantId: this.user.myExtension.tenantId,
            number: parkerNum
          }
        });

        if(extenLookup.length){
          parkerExten = `${extenLookup[0].name} - ${parkerNum}`;
        }

        this.parkPushNotify(+parkingSpace, callerNumber, callerName, parkerExten);
        this.$message({
          message: `You have a newly parked call from extension ${parkerExten}`,
          type: 'warning',
          duration: 5000
        });
      });

      //handle parkExit event
      channelMemberships.on('parkExit', (evt) => {
        this.$store.commit('myparkedcalls/removeItem', evt.parkingSpace);
      })

      //listen for refreshing connected calls
      channelMemberships.on('notifyUserActiveCall', (evt) => {
        if(this.user.hasOwnProperty('myExtension')){
          const {channels} = evt;
          const callsCount = channels.length;
          for(let i = 0; i < callsCount; i++){
            const theCall = channels[i];
            const {channel, exten, connectedlinenum, connectedlinename, timestamp, direction, hostName, peerName} = theCall;
            if(peerName === this.user.myExtension.peerName){
              if(!this.checkCallExists(theCall)){
                let cidnum = connectedlinenum === '<unknown>' ? exten : connectedlinenum;
                let cidname = connectedlinename === '<unknown>' ? '' : connectedlinename;
                const callData = {
                  channel,
                  cidnum,
                  cidname,
                  direction,
                  peername: peerName,
                  systemname: hostName,
                  duration: moment().unix() - timestamp,
                  disabledButtons: false
                };
                this.$store.commit('mycurrentcalls/addItem', callData);
              }
            }
          }
        }
      });

      channelMemberships.on('atxferMergeComplete', async (evt) => {

        const {channel, target} = evt;

        const call = this.myCallsList({query: {channel}}).data;

        if(call.length){
          let participants = call[0].participants;

          if(participants === undefined){

            let callerName = call[0].cidname;
            //check the first caller to see if we can give them an appropriate name
            const personalContact = this.loadPersonalDirectory({
              query: {
                "PHONE1": call[0].cidnum
              }
            }).data;
            if(personalContact.length){
              callerName = personalContact[0].NAME;
            }

            participants = [
              {
                name: `${this.user.myExtension.name} (Me)`,
                number: this.user.myExtension.number
              },
              {
                name: callerName.length ? callerName : 'Unknown',
                number: call[0].cidnum
              }
            ];
          }

          //check the name. if not given try to find it in the personal directory
          let mergeCallerName = 'Unknown';
          const bizContact = await feathersClient.service('extensions').find({
            query: {
              tenantId: this.user.myExtension.tenantId,
              number: target
            }
          });
          if(bizContact.length){
            mergeCallerName = bizContact[0].name;
          } else{
            const personalContact = this.loadPersonalDirectory({
              query: {
                "PHONE1": target
              }
            }).data;
            if(personalContact.length){
              mergeCallerName = personalContact[0].NAME;
            }
          }

          participants.push({
            name: mergeCallerName,
            number: target
          });

          this.$store.commit('mycurrentcalls/updateItem', {
            channel: evt.channel,
            conferencing: true,
            participants,
            bridgeId: evt.bridgeId
          });
        }

      });

      channelMemberships.on('conferenceChannel', this.emitConferenceChannel);
      channelMemberships.on('conferenceInfoComplete', this.emitConferenceInfoComplete);

      //in case a user is updated while in session and access changes.
      userService.on('updateUserTenants', item => {
        this.$store.commit('users/updateItem', {id: item.id, tenantIds: item.tenantIds});
        const currentTenants = this.$store.state.authTenants;
        this.$store.commit('setTenants', [...currentTenants, item.newAccount]);
      });

      channelMemberships.on('userPhonebookUpdate', item => {
        if(item.userId === this.user.id){
          let extensionData = {...this.user.myExtension};
          extensionData.omniaPhonebookId = item.recordId;
          this.$store.commit('users/updateItem', {id: item.userId, myExtension: extensionData});
          this.$store.dispatch("phonebook-entries/find", {
            query: {
              tenantId: this.user.tenantId,
              phonebookId: item.recordId
            }
          });
        }
      });

      userService.on('userAvatarUpdate', item => {
        this.$store.commit('users/updateItem', {
          id: item.userId,
          avatarFileName: item.avatarFileName,
          avatarPath: item.avatarPath
        });
      });

      //socket client connection event listeners.
      feathersClient.io.on('disconnect', () => {
        console.log('api disconnect detected');

        //emit the app disconnect event and show notification
        globalEventBus.$emit('appDisconnected');
        this.$notify({
          title: 'Connection Error',
          type: 'error',
          duration: 0,
          showClose: false,
          dangerouslyUseHTMLString: true,
          message: `<div class="offline-notification" style="display: flex; margin-left: -40px;">
                      <div class="el-loading-spinner mt-20" style="position: relative; width: auto;">
                        <svg viewBox="13 13 25 25" class="circular">
                          <circle cx="25" cy="25" r="10" fill="none" class="path"></circle>
                        </svg>
                      </div>
                      <div class="ml-20 mt-20">We are trying to re-initiate the connection to the application</div>
                    </div>`
        });
      });

      feathersClient.io.on('reconnect',async () => {
        console.log('we must be trying to reconnect');
        if(this.user){
          this.clearMyCalls();
          await this.joinUserChannels();
          globalEventBus.$emit('appReconnected');
          this.$notify.closeAll();
        } else{
          console.log('no user after reconnect');
          this.$notify.closeAll();
        }
      });


      //version update handler
      globalEventBus.$on('versionUpdate', () => {
        this.$store.commit("whatsNewBadge", "");
      });

      //Sip Softphone Event Handlers
      globalEventBus.$on('softphoneSendDTMF', (evt) => {
        const {sipHandle, value, callItem} = evt;
        this.sipDad.sendDTMF(sipHandle.uniqueId, value, callItem);
      });

      globalEventBus.$on('softphoneSwapAtxfer', (sipHandle) => {
        const { uniqueId, callItem } = sipHandle;
        this.sipDad.attendedTransferSwap(uniqueId, callItem);
      });

      globalEventBus.$on('softphoneMergeAtxfer', (sipHandle) => {
        const { uniqueId, callItem} = sipHandle;
        this.sipDad.attendedTransferMerge(uniqueId, callItem);
      });

      globalEventBus.$on('softphoneCancelAtxfer', (sipHandle) => {
        const { uniqueId, callItem } = sipHandle
        this.sipDad.attendedTransferCancel(uniqueId, callItem);
      });

      globalEventBus.$on('softphoneParkForUser', (evt) => {
        const {sipHandle, destination, callItem} = evt;
        this.sipDad.parkForUser(sipHandle.uniqueId, destination, callItem);
      });

      globalEventBus.$on('softphoneProcessTransfer', (evt) => {
        const {sipHandle, destination, quickTransferActive, channel}= evt;
        this.sipDad.transfer(sipHandle.uniqueId, destination, quickTransferActive);
        this.$store.commit('mycurrentcalls/removeItem', channel);
      });

      globalEventBus.$on('softphoneProcessAttendedTransfer', async (evt) => {
        const {sipHandle, destination, callItem} = evt;
        await this.sipDad.unhold(sipHandle.uniqueId);
        this.sipDad.attendedTransfer(sipHandle.uniqueId, destination, callItem);
      });

      globalEventBus.$on('softphoneConnectedCallHangup', (evt) => {
        this.sipDad.hangup(evt.uniqueId);
      });

      globalEventBus.$on('softphoneCallUnhold', async (sipHandle) => {
        const {uniqueId, cidNum, cidName} = sipHandle;
        await this.sipDad.holdOtherCalls(uniqueId);
        this.updateStoreCalls(cidNum, {uniqueId, cidName, cidNum})
        this.sipDad.unhold(uniqueId);
      });

      globalEventBus.$on('softphoneCallHold', (sipHandle) => {
        this.sipDad.hold(sipHandle.uniqueId);
      });

      globalEventBus.$on('softphoneMute', (sipHandle) => {
        this.sipDad.mute(sipHandle.uniqueId);
      });

      globalEventBus.$on('softphoneUnmute', (sipHandle) => {
        this.sipDad.unmute(sipHandle.uniqueId);
      })

      globalEventBus.$on('dialSoftphone', (number) => {
        this.dialSoftphone(number);
      });

      globalEventBus.$on('headsetHangupCall', (uniqueId) => {
        this.sipDad.hangup(uniqueId);
      });

      globalEventBus.$on('softphoneToggleRecording', (data) => {

        const {uniqueId, pause, direction, systemname, channel} = data;

        if(uniqueId) {
          const callItem = {channel, systemname};
          this.sipDad.toggleRecording(uniqueId, pause, callItem);
        } else{
          //use api directly to control call that originated elsewhere (not this softphone)
          const callDirection = direction === 'initiator' ? 'outbound' : 'inbound';
          const state = pause ? 1 : 0;

          feathersClient.service('nats-actions-handler').create({
            reqType: 'muteRecording',
            channel,
            server: systemname,
            state,
            direction: callDirection
          });
        }
      });

      channelMemberships.on('networkTestResults', (evt) => {
        const {packetLoss, percentJitter, mos, rtt} = evt;
        this.networkTestData = [
          {name: 'Latency', value: `${rtt} ms`},
          {name: 'Packet Loss', value: `${packetLoss} %`},
          {name: 'Percent Jitter', value: `${percentJitter} %`},
          {name: 'MOS', value: mos}
        ]
      });

      //this is the handler for push notification interactions
      navigator.serviceWorker.addEventListener('message', event => {

        const {msg, sipHandleId, parkingSpace} = event.data;
        if(msg === 'pushCallAccepted'){
          globalEventBus.$emit(`pushAcceptCall-${sipHandleId}`);
          return;
        }
        if(msg === 'pushCallDeclined'){
          globalEventBus.$emit(`pushDeclineCall-${sipHandleId}`);
          return;
        }
        if(msg === 'parkAccepted'){
          if(this.softphoneEnabled){
            this.dialSoftphone(+parkingSpace);
          } else {
            this.$notify({
              title: 'Warning',
              message: 'Enable softphone to pick up parked call.',
              type: 'warning'
            });
          }
        }

      });

      //visibility listener
      document.addEventListener('visibilitychange', () => {
        if(document.visibilityState !== 'visible'){
          this.modKeyActive = false;
        }
      });

      //global hot key listeners
      window.addEventListener('keydown', e => {
        if(e.key === 'Alt'){
          e.preventDefault();
          this.modKeyActive = true;
        }
        //to launch dialer, softphone must be enabled and user must be logged in.
        if(this.softphoneEnabled && this.user && this.modKeyActive){
          e.preventDefault();
          if(e.code === 'KeyD'){
            this.keyPadVisible ? this.$store.commit('setSoftphoneVisibility', false) : this.$store.commit('setSoftphoneVisibility', true);
          }
        }
      });

      //listener for hot key modifier key
      window.addEventListener('keyup', e => {
        if(e.key === 'Alt'){
          this.modKeyActive = false;
        }
      });

    },
    beforeMount() {
      body.className = this.$store.state.layout.theme;
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeOpenNav);
      window.removeEventListener('beforeunload', this.confirmUnloadDuringCall);
    }
  }
</script>
